import { Record as record } from 'immutable';

import CheapestFares from './CheapestFares';
import Service from './Service';
import { construct, resolve } from '../helpers/LinkMapper';
import { JourneyDirections } from '../constants/AppConstants';

const defaults = {
    outwardService: null,
    inboundService: null,
    cheapestFares: null
};

class OverallCheapestSelection extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(OverallCheapestSelection, json, {
            outwardService: resolve.as(Service),
            inboundService: resolve.as(Service),
            cheapestFares: resolve.as(CheapestFares)
        });
    }

    static fromServices (outward, inbound, trip) {
        const filter = (service)=> !service.isDisabledForTrip(trip);
        let cheapestFares = null,
            outwardService = new Service(),
            inboundService = new Service();

        outward.filter(filter).map((service)=> {
            if (!cheapestFares || service.getCheapestTotalPrice() < cheapestFares.totalPrice) {
                cheapestFares = service.fares.cheapest;
            }
        });

        inbound.filter(filter).map((service)=> {
            if (!cheapestFares || service.getCheapestTotalPrice() < cheapestFares.totalPrice) {
                cheapestFares = service.fares.cheapest.reverseSingles();
            }
        });

        if (!cheapestFares) {
            return new OverallCheapestSelection();
        }

        if (cheapestFares.outwardSingle) {
            outwardService = outward.find((service)=> {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.outwardSingle);
            });
        }

        if (cheapestFares.inboundSingle) {
            inboundService = inbound.find((service)=> {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.inboundSingle);
            });
        }

        if (cheapestFares.return) {
            outwardService = outward.find((service)=> {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.return);
            });

            inboundService = inbound.find((service)=> {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.return);
            });
        }

        if (!outwardService && !inboundService) {
            return new OverallCheapestSelection();
        }

        return new OverallCheapestSelection({
            cheapestFares,
            outwardService,
            inboundService
        });
    }

    isCheapestFare (fare) {
        return !!this.cheapestFares && this.cheapestFares.isCheapestFare(fare);
    }

    getOutwardFare () {
        return this.cheapestFares.outwardSingle;
    }

    hasOutwardFare () {
        return Boolean(this.getIn(['cheapestFares', 'outwardSingle']));
    }

    getInwardFare () {
        return this.cheapestFares.inboundSingle;
    }

    hasInwardFare () {
        return Boolean(this.getIn(['cheapestFares', 'inboundSingle']));
    }

    getReturnFare () {
        return this.cheapestFares.return;
    }

    hasReturnFare () {
        return Boolean(this.getIn(['cheapestFares', 'return']));
    }

    getFareForDirection (direction) {
        if (!this.cheapestFares) {
            return null;
        }

        if (direction === JourneyDirections.INWARD) {
            return this.getInwardFare();
        }
        return this.getReturnFare() || this.getOutwardFare();
    }

    getServiceForDirection (direction) {
        return direction === JourneyDirections.OUTWARD ? this.outwardService : this.inboundService;
    }

    getTripDuration() {
        const {outwardService, inboundService} = this;
        return (
            outwardService &&
            outwardService.getTripDuration().add(inboundService && inboundService.getTripDuration())
        );
    }

    getPrice() {
        return this.cheapestFares && this.cheapestFares.totalPrice;
    }
}

export default OverallCheapestSelection;



// WEBPACK FOOTER //
// ./src/records/OverallCheapestSelection.js